module.exports = __webpack_public_path__ + "static/logo-152b3b3404d0255fe55de709b68c533a.svg";